import { render, staticRenderFns } from "./UIFilters.vue?vue&type=template&id=32ce4237&scoped=true&"
import script from "./UIFilters.vue?vue&type=script&lang=js&"
export * from "./UIFilters.vue?vue&type=script&lang=js&"
import style0 from "../assets/css/ui.css?vue&type=style&index=0&id=32ce4237&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ce4237",
  null
  
)

export default component.exports